import { render, staticRenderFns } from "./procurementBidding copy.vue?vue&type=template&id=e6920996&scoped=true"
import script from "./procurementBidding copy.vue?vue&type=script&lang=js"
export * from "./procurementBidding copy.vue?vue&type=script&lang=js"
import style0 from "./procurementBidding copy.vue?vue&type=style&index=0&id=e6920996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6920996",
  null
  
)

export default component.exports